import React, { useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import "./JobDetails.scss";
import { Details } from "../candidateDetails/details";


export default function ProfileDetails({ closePopup }) {
  
  return (
    <section>
     
      {/* profile details popup */}
    
        <div className="popup-container full-width-popup ">
          <div
            className="shadeClose"
            onClick={() => {
              closePopup();
            }}
          ></div>
          <div className="popup-inner">
            <div className="inner-design">
              <div className="popup-header d-flex align-items-center gap2">
                <h2>Christopher Nolen</h2>
                <button
                  type="button"
                  className="ms-auto close-btn"
                  onClick={() => {
                    closePopup();
                  }}
                >
                  <IoCloseOutline />
                </button>
              </div>

              <div className="popup-content full-height">
                <Details />
              </div>
            </div></div>
        </div>
      
     
    </section>

  );
}
